/**
 * AnalyseFitExplainer.jsx — RC 1.41.G4.A
 *
 * Canonical user-facing explanation of what NDOR Analyse-Fit
 * evaluates. Single source of truth so the copy never drifts
 * across surfaces (Job detail, Wizard Step 1, Wizard Step 3).
 *
 * Hard rules (RC 1.41.G4.A):
 *   • Preserve proprietary weighting logic — no formula, no
 *     sub-score weights, no prompt detail surfaced.
 *   • Two display modes:
 *       compact  — small italic line below an action button.
 *       expanded — full disclosure card with the canonical copy.
 *   • The component is purely presentational — no API call, no
 *     state, no side effect.
 */

import React from 'react';
import { Sparkles } from 'lucide-react';

const ANALYSE_FIT_BLURB =
  "Your selected CV, profile, preferences, salary, seniority, location, " +
  "strategic alignment, risk and (when relevant) your cover letter. " +
  "NDOR provides an application-readiness verdict beyond keyword matching.";

const ANALYSE_FIT_TIP =
  "Tip: a complete profile and accurate preferences materially improve result quality.";

export function AnalyseFitExplainer({ variant = 'expanded', testIdSuffix = '' }) {
  const tid = testIdSuffix
    ? `analyse-fit-explainer-${testIdSuffix}`
    : 'analyse-fit-explainer';

  if (variant === 'compact') {
    return (
      <p
        className="text-[11px] text-ndor-ink-muted italic leading-relaxed"
        data-testid={tid}
      >
        NDOR Analyse-Fit evaluates {ANALYSE_FIT_BLURB.charAt(0).toLowerCase() + ANALYSE_FIT_BLURB.slice(1)}
      </p>
    );
  }

  return (
    <div
      className="rounded-lg border border-ndor-edge bg-ndor-surface-alt/30 p-3 space-y-1.5"
      data-testid={tid}
    >
      <p className="text-xs font-medium text-ndor-ink flex items-center gap-1.5">
        <Sparkles className="h-3.5 w-3.5 text-ndor-gold" />
        What NDOR Analyse-Fit looks at
      </p>
      <p className="text-xs text-ndor-ink-secondary leading-relaxed">
        {ANALYSE_FIT_BLURB}
      </p>
      <p className="text-[11px] text-ndor-ink-muted italic leading-relaxed">
        {ANALYSE_FIT_TIP}
      </p>
    </div>
  );
}

export default AnalyseFitExplainer;
